import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {jwtDecode} from "jwt-decode";
import {CommonResponse} from "../../customs/_models/Response";
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class SecurityService {

    accesToken : string
  constructor(private http : HttpClient,
              private endPoinds : Endpoints) { }

   /* public login(username : string, password: string){
      let options = {
          headers : new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
      }
      let params = new HttpParams().set("username" , username).set("password" , password);
        return this.http.post<CommonResponse>(`${environment.base_url}/api/auth/login`, params, options)
    }*/


public login(username: string, password: string) {
  const body = { username, password };
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  return this.http.post<CommonResponse>(`${environment.base_url}/api/auth/login`, body, { headers })
    .pipe(
      tap(res => {
        // 🔹 Stocker le token seulement si la réponse est valide
        if (res.status && res.data && res.data.token) {
          sessionStorage.setItem('user_token', res.data.token);
          console.log('📦 Token stocké dans sessionStorage :', res.data.token);
        }
      })
    );
}


    public loadProfile(data: any){
      this.accesToken = data['acces_token']
        let decodedJwt = jwtDecode(this.accesToken)
    }
}
